





















































































































































































































































































/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import BdSwitch from '@/components/bd-switch';
import { IOnSeparateForm, onSeparateFormDefault, IOnSeparateFormArr, onSeparateFormArrDefault } from './type';

@Component({
  components: { BdSwitch },
  methods: {
    moment
  }
})
export default class SplitPartRule extends Vue {
  // @Prop({
  //   type: String,
  //   default: '',
  // })
  // datePattern!: string

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop()
  onSeparateForm!: IOnSeparateForm;
  // = onSeparateFormDefault
  @Prop()
  onSeparateFormArr!: IOnSeparateFormArr[];
  // = onSeparateFormArrDefault
  range(start: any, end: number) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }
  mounted() {}

  formAdd(array: IOnSeparateFormArr[]) {
    const length = array.length;
    const firstItem = array[0];
    const lastItem = array[length - 1];

    const lastStartMoment = moment(lastItem.startTime, 'HH:mm');
    const lastEndMoment = moment(lastItem.endTime, 'HH:mm');
    const lastDiff = lastEndMoment.diff(lastStartMoment);
    const isInteger = (lastDiff / (1000 * 60) - lastItem.startChargeTime) % lastItem.cycleChargeTime === 0;

    if (!lastItem.startTime || !lastItem.endTime) {
      this.$message.error('请输入本次分段的计时开始和结束时间');
    } else if (lastDiff === 0) {
      this.$message.error('本次分段的开始时间不能与结束时间相等');
    } else if (lastDiff <= 0 && lastEndMoment.format('HH:mm') !== '00:00') {
      this.$message.error('本次分段的结束时间只能为00:00或比开始时间大');
    } else if (lastEndMoment.diff(moment(firstItem.startTime, 'HH:mm')) === 0) {
      this.$message.error('本次分段计费已完成整个周期,不能继续添加');
    } else if (!isInteger) {
      this.$message.error('当前起步时段与循环时段无法组合为[起步时间-结束时间]的时间差,请核实!');
    } else {
      array.push({
        startTime: lastItem.endTime,
        endTime: lastItem.startTime,
        startChargeTime: 60,
        startChargeMoney: 1,
        freeTime: 30,
        topMoneyOfSection: 0,
        cycleChargeTime: 60,
        cycleChargeMoney: 1
      } as any);
    }
  }
  formRemove(arr: IOnSeparateFormArr[]) {
    if (arr.length > 1) {
      arr.pop();
    } else {
      this.$message.error('分段计费最少要有一个时间段!');
    }
  }
  getDisabledHours(type: any) {
    const hours: number[] = [];
    this.onSeparateFormArr.forEach(item => {
      const timeArr = item.startTime.split(':');
      for (var i = 0; i < parseInt(timeArr[0]); i++) {
        hours.push(i);
      }
    });
    return hours;
  }
  getDisabledMinutes(selectedHour: number) {
    const minutes: number[] = [];
    this.onSeparateFormArr.forEach(item => {
      const timeArr = item.startTime.split(':');
      if (selectedHour == parseInt(timeArr[0])) {
        for (var i = 0; i < parseInt(timeArr[1]); i++) {
          minutes.push(i);
        }
      }
    });
    return minutes;
  }

  getDisabledHoursT(type: any) {
    const hours: number[] = [];
    this.onSeparateFormArr.forEach(item => {
      const timeArr = item.endTime.split(':');
      for (var i = parseInt(timeArr[0]) + 1; i <= 24; i++) {
        // debugger
        console.log('parseInt(timeArr[0])', parseInt(timeArr[0]));
        hours.push(i);
      }
    });
    return hours;
  }

  // 分段计费111
  addSeparate() {
    try {
      if (
        this.onSeparateForm &&
        this.onSeparateForm.limitMoneyOfDefines.length > 0 &&
        this.onSeparateForm.limitMoneyOfDefines[this.onSeparateForm.limitMoneyOfDefines.length - 1].limitTime !== 0 &&
        this.onSeparateForm.limitMoneyOfDefines[this.onSeparateForm.limitMoneyOfDefines.length - 1].money !== 0
      ) {
        this.onSeparateForm.limitMoneyOfDefines.push({ limitTime: 0, money: 0 });
      } else {
        return this.$message.warning('请填写完整');
      }
    } catch (e) {
      console.log(e);
    }
  }
  delSeparate(index: number) {
    try {
      if (this.onSeparateForm && this.onSeparateForm.limitMoneyOfDefines.length > 1) {
        this.onSeparateForm.limitMoneyOfDefines.splice(index, 1);
      }
    } catch (e) {
      console.log(e);
    }
  }
}
